let splideInstance = null;

function handleAnnouncementSlider() {
  const el = document.querySelector("[data-announcement-slider]");
  if (!el) return;

  const mobile = window.innerWidth < 700;

  if (mobile && !splideInstance) {
    el.classList.add("splide");
    splideInstance = new Splide(el, {
      type: "loop",
      perPage: 1,
      autoplay: true,
      interval: 5000,
      arrows: false,
      pagination: false,
      speed: 1000,
    }).mount();
  }

  if (!mobile && splideInstance) {
    splideInstance.destroy("completely");
    splideInstance = null;
    el.classList.remove("splide"); //
  }
}

const debounced = (fn, delay = 200) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(null, args), delay);
  };
};

document.addEventListener("DOMContentLoaded", () => {
  handleAnnouncementSlider();
  window.addEventListener("resize", debounced(handleAnnouncementSlider));
});
